import { useState } from "react";
import { toast } from "react-toastify";
import AssetsService from "../../../rest/assetsService";
import ProductService from "../../../rest/productService";
import Modal from "../../../components/lib/modal"; 
import ProductRegisterStepper from "./productRegisterStepper";
import ConfirmCloseView from "../../customers/components/confirmCloseView";

const ProductRegisterModal = ({ isOpen, setIsOpen }) => {
    const [hasData, setHasData] = useState(false);
    const [confirmClose, setConfirmClose] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const requestClose = () => {
        if (hasData) {
            setConfirmClose(true);
        } else {
            setIsOpen(false);
        }
    };

    const forceClose = () => {
        setConfirmClose(false);
        setIsOpen(false);
    };

    const handleFinish = async ({ product, nutrition, image }) => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            let image_url = null;
            if (image) {
                const formData = new FormData();
                formData.append("file", image);
                const upload = await AssetsService.uploadProductImage(formData);
                image_url = upload.data;
            }

            await ProductService.registerProduct({
                ...product,
                nutritional_facts: JSON.stringify(nutrition),
                image_url,
                clientCode: sessionStorage.getItem("clientCode"),
            });

            toast.success("Produto cadastrado com sucesso!");
            setIsOpen(false);
        } catch (err) {
            console.error(err);
            toast.error("Erro ao cadastrar produto.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            setIsOpen={requestClose}
            title="Cadastrar Produto"
            hideFooter
            maxWidth="max-w-xl lg:max-w-2xl md:-mr-16"
        >
            <div className="relative h-full flex flex-col">
                <ProductRegisterStepper
                    onDirty={() => setHasData(true)}
                    onCancel={requestClose}
                    onFinish={handleFinish}
                    isSubmitting={isSubmitting}
                />

                {confirmClose && (
                    <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/95 backdrop-blur-sm p-4 rounded-lg">
                        <ConfirmCloseView
                            onCancel={() => setConfirmClose(false)}
                            onConfirm={forceClose}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ProductRegisterModal;